// SketchContext.js
//
// Opens the SKETCH modal from any openNode / capture path.

import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const SketchContext = createContext(null);

export const SketchProvider = ({ children }) => {
  const [isSketchOpen, setIsSketchOpen] = useState(false);
  const [sketchNode, setSketchNode] = useState(null);

  const openSketch = useCallback((node) => {
    const key = typeof node?.key === 'string' ? node.key.trim() : '';
    if (!key) return;
    setSketchNode(node);
    setIsSketchOpen(true);
  }, []);

  const closeSketch = useCallback(() => {
    setIsSketchOpen(false);
    setSketchNode(null);
  }, []);

  const value = useMemo(() => ({
    closeSketch,
    isSketchOpen,
    openSketch,
    sketchNode,
  }), [closeSketch, isSketchOpen, openSketch, sketchNode]);

  return (
    <SketchContext.Provider value={value}>
      {children}
    </SketchContext.Provider>
  );
};

export const useSketch = () => {
  const context = useContext(SketchContext);
  if (!context) {
    throw new Error('useSketch must be used within SketchProvider');
  }
  return context;
};

export const useOptionalSketch = () => useContext(SketchContext);

export default SketchContext;
